import { DaoService } from "./DaoService";

export class MembreTacheService extends DaoService {

    static CLASS_NAME = "App\\Models\\MembreTache";
    
    static getInstance() {
        return super.getInstance('membretache');
    }

    search(data) {
        return MembreTacheService.post(`${this.prefix}/search`, data);
    }

}